<div class="settings-container">
  <!-- Header -->
  <div class="settings-header">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-gray-100">Theme Settings</h1>
      <p class="text-gray-600 dark:text-gray-400 mt-1">Customize your application theme with 5 colors</p>
    </div>
    <div class="flex items-center space-x-3">
      <app-button variant="secondary" (clicked)="resetTheme()">
        Reset to Default
      </app-button>
      <app-button variant="primary" (clicked)="saveTheme()">
        Save Theme
      </app-button>
    </div>
  </div>

  <!-- Language Selection -->
  <div class="settings-section">
    <h2 class="section-title">Language</h2>
    <div class="language-selection-container">
      <div class="flex items-center justify-between">
        <div>
          <h3 class="mode-label">Select Language</h3>
          <p class="mode-description">Choose your preferred language for the application</p>
        </div>
        <div class="language-options">
          <button
            type="button"
            [class]="'language-option ' + (currentLanguage === 'en' ? 'language-active' : '')"
            (click)="selectLanguage('en')">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
            </svg>
            <span>English</span>
            <svg *ngIf="currentLanguage === 'en'" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </button>
          <button
            type="button"
            [class]="'language-option ' + (currentLanguage === 'mr' ? 'language-active' : '')"
            (click)="selectLanguage('mr')">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
            </svg>
            <span>मराठी</span>
            <svg *ngIf="currentLanguage === 'mr'" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </button>
          <button
            type="button"
            [class]="'language-option ' + (currentLanguage === 'hi' ? 'language-active' : '')"
            (click)="selectLanguage('hi')">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
            </svg>
            <span>हिंदी</span>
            <svg *ngIf="currentLanguage === 'hi'" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Dark/Light Mode Toggle -->
  <div class="settings-section">
    <h2 class="section-title">Appearance</h2>
    <div class="mode-toggle-container">
      <div class="flex items-center justify-between">
        <div>
          <h3 class="mode-label">Theme Mode</h3>
          <p class="mode-description">Switch between light and dark mode</p>
        </div>
        <div class="mode-toggle-wrapper">
          <button
            type="button"
            [class]="'mode-toggle ' + (currentMode() === 'light' ? 'mode-active' : '')"
            (click)="setMode('light')">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
            </svg>
            <span>Light</span>
          </button>
          <button
            type="button"
            [class]="'mode-toggle ' + (currentMode() === 'dark' ? 'mode-active' : '')"
            (click)="setMode('dark')">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
            </svg>
            <span>Dark</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Theme Presets -->
  <div class="settings-section">
    <h2 class="section-title">Theme Presets</h2>
    <div class="preset-grid">
      <button
        *ngFor="let preset of themePresets"
        [class]="'preset-card ' + (selectedPreset() === preset.name ? 'preset-active' : '')"
        (click)="selectPreset(preset.name)">
        <div class="preset-colors">
          <div class="preset-color" [style.background-color]="preset.theme.color1"></div>
          <div class="preset-color" [style.background-color]="preset.theme.color2"></div>
          <div class="preset-color" [style.background-color]="preset.theme.color3"></div>
          <div class="preset-color" [style.background-color]="preset.theme.color4"></div>
          <div class="preset-color" [style.background-color]="preset.theme.color5"></div>
        </div>
        <p class="preset-name">{{ preset.name }}</p>
      </button>
      
      <button
        [class]="'preset-card ' + (isCustomTheme() && selectedPreset() === 'custom' ? 'preset-active' : '')"
        (click)="selectPreset('custom')">
        <div class="preset-colors">
          <div class="preset-color" [style.background-color]="color1()"></div>
          <div class="preset-color" [style.background-color]="color2()"></div>
          <div class="preset-color" [style.background-color]="color3()"></div>
          <div class="preset-color" [style.background-color]="color4()"></div>
          <div class="preset-color" [style.background-color]="color5()"></div>
        </div>
        <p class="preset-name">Custom Theme</p>
      </button>
    </div>
  </div>

  <!-- Custom Color Picker -->
  <div class="settings-section">
    <h2 class="section-title">Custom Colors</h2>
    <div class="color-picker-grid">
      <div class="color-picker-item">
        <label class="color-label">{{ getColorLabel(1) }}</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [value]="color1()"
            (input)="onColorChange(1, $any($event.target).value)"
            class="color-picker" />
          <input
            type="text"
            [value]="color1()"
            (input)="onColorChange(1, $any($event.target).value)"
            class="color-text-input" />
        </div>
      </div>

      <div class="color-picker-item">
        <label class="color-label">{{ getColorLabel(2) }}</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [value]="color2()"
            (input)="onColorChange(2, $any($event.target).value)"
            class="color-picker" />
          <input
            type="text"
            [value]="color2()"
            (input)="onColorChange(2, $any($event.target).value)"
            class="color-text-input" />
        </div>
      </div>

      <div class="color-picker-item">
        <label class="color-label">{{ getColorLabel(3) }}</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [value]="color3()"
            (input)="onColorChange(3, $any($event.target).value)"
            class="color-picker" />
          <input
            type="text"
            [value]="color3()"
            (input)="onColorChange(3, $any($event.target).value)"
            class="color-text-input" />
        </div>
      </div>

      <div class="color-picker-item">
        <label class="color-label">{{ getColorLabel(4) }}</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [value]="color4()"
            (input)="onColorChange(4, $any($event.target).value)"
            class="color-picker" />
          <input
            type="text"
            [value]="color4()"
            (input)="onColorChange(4, $any($event.target).value)"
            class="color-text-input" />
        </div>
      </div>

      <div class="color-picker-item">
        <label class="color-label">{{ getColorLabel(5) }}</label>
        <div class="color-input-wrapper">
          <input
            type="color"
            [value]="color5()"
            (input)="onColorChange(5, $any($event.target).value)"
            class="color-picker" />
          <input
            type="text"
            [value]="color5()"
            (input)="onColorChange(5, $any($event.target).value)"
            class="color-text-input" />
        </div>
      </div>
    </div>
  </div>

  <!-- Preview Section -->
  <div class="settings-section">
    <h2 class="section-title">Theme Preview</h2>
    <div class="preview-container">
      <div class="preview-card">
        <div class="preview-header" [style.background]="'linear-gradient(135deg, ' + color1() + ', ' + color2() + ')'">
          <h3 class="preview-title">Preview Card</h3>
        </div>
        <div class="preview-content">
          <p class="preview-text">This is how your theme will look across the application.</p>
          <div class="preview-buttons">
            <button class="preview-btn-primary" [style.background-color]="color1()">
              Primary Button
            </button>
            <button class="preview-btn-secondary" [style.background-color]="color2()">
              Secondary Button
            </button>
            <button class="preview-btn-accent" [style.background-color]="color3()">
              Accent Button
            </button>
          </div>
          <div class="preview-badges">
            <span class="preview-badge" [style.background-color]="color4() + '20'" [style.color]="color4()">
              Success Badge
            </span>
            <span class="preview-badge" [style.background-color]="color5() + '20'" [style.color]="color5()">
              Warning Badge
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
